module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/studio-suns_spot_01-981de1fc191726def34013b2f665cbfe.jpg";